import { render } from "./type.vue?vue&type=template&id=365778d0&scoped=true"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"

import "./type.vue?vue&type=style&index=0&id=365778d0&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365778d0"]])

export default __exports__